import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  monospace?: boolean;
}

const baseClasses =
  'block w-full rounded-md border border-stone-800 bg-stone-900 px-3 py-2 text-sm ' +
  'text-stone-100 placeholder:text-stone-700 ' +
  'focus:border-amber-700/60 focus:outline-none focus:ring-1 focus:ring-amber-700/40 ' +
  'disabled:cursor-not-allowed disabled:opacity-60 ' +
  'resize-y';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, monospace, className, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        baseClasses,
        monospace ? 'font-mono leading-[1.7]' : 'font-sans',
        invalid && 'border-red-700/60 focus:border-red-700',
        className,
      )}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
});
